import { defineElement, BaseElement } from '@webtides/element-js';

export default class ViewportInformation extends BaseElement {
    connected() {
        try {
            const resizeObserver = new ResizeObserver(() => {
                this.onResize();
            });
            resizeObserver.observe(document.documentElement);
        } catch (e) {
            /**
             *  just catch errors to not produce js errors if ResizeOberserver is not supported
             *  fallback to legacy resize
             *  */
            window.addEventListener('resize', () => this.onResize());
        }
        this.onResize();
    }

    onResize() {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const vw = document.documentElement.clientWidth / 100;
        document.documentElement.style.setProperty('--scroll-bar-width', scrollbarWidth + 'px');
        document.documentElement.style.setProperty('--vw', vw + 'px');
    }
}

defineElement('viewport-information', ViewportInformation);
